import { showLoginPanel } from '@/config/qdAdminCommon';
import { isPrivate } from 'src/config/private';
const loginPanelConfig = {
    loginSuccessCb() {
        window.location.reload();
    },
    loginShowConfig: isPrivate ? 'a' : 'mq',
};
const loginPanel = () => {
    return showLoginPanel(loginPanelConfig);
};
export default loginPanel;
